import request from '@/request'
const part_url = '/train/web/company/';

function getCompanyList() {
    let url = part_url + "list";
    return request.get(url, {})
}

export default {
    getCompanyList
}


// WEBPACK FOOTER //
// ./src/api/company.js